module.exports = __webpack_public_path__ + "img/customer.f1d7f9c9.png";